import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  translate,
  SimpleForm,
  Toolbar,
  SaveButton,
  showNotification,
  FileInput,
  FileField,
  ArrayInput,
  SimpleFormIterator,
  TextInput,
} from 'react-admin';
import withStyles from '@material-ui/core/styles/withStyles';
import compose from 'recompose/compose';
import qs from 'qs';
import { withRouter } from 'react-router';
import Drawer from '@material-ui/core/Drawer';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress';
import Divider from '@material-ui/core/Divider';
import MuiTextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import resourceConfig from './config';
import request from '../../../../network/request';
import { paramToDictionary } from '../../../../utils';
import Snackbar from '../../../../components/Snackbar';

const styles = {
  toolbar: { background: 'none' },
  loader: { marginLeft: 15 },
  divider: { margin: '24px 0' },
  sectionTitle: { marginBottom: 8 },
  uitRow: { display: 'flex', alignItems: 'center', gap: 16, marginTop: 8 },
  uitField: { flex: 1 },
  submitBtn: { marginTop: 8, whiteSpace: 'nowrap', minWidth: 110 },
  responseCard: { marginTop: 16, background: '#f5f5f5' },
  responseRow: { display: 'flex', padding: '4px 0', borderBottom: '1px solid #e0e0e0' },
  responseKey: { fontWeight: 600, minWidth: 200, color: '#555', fontSize: 13 },
  responseVal: { fontSize: 13, wordBreak: 'break-all' },
};

const FormToolbar = translate(({ translate, ...props }) => (
  <Toolbar style={styles.toolbar} {...props}>
    <SaveButton
      label={translate(`resources.${resourceConfig.name}.executeAction`)}
      redirect={false}
      submitOnEnter={false}
    />
    {props.saving && (
      <div style={styles.loader}>
        <CircularProgress />
      </div>
    )}
  </Toolbar>
));

const CIS_INFO_LABELS = {
  cis: 'КМ (cis)',
  requestedCis: 'Запрошенный КМ',
  status: 'Статус ГИС МТ',
  statusEx: 'Специальный статус',
  gtin: 'GTIN',
  ownerInn: 'ИНН владельца',
  ownerName: 'Наименование владельца',
  producerInn: 'ИНН производителя',
  producerName: 'Наименование производителя',
  emissionDate: 'Дата эмиссии',
  emissionType: 'Тип эмиссии',
  introducedDate: 'Дата ввода в оборот',
  applicationDate: 'Дата заявки',
  productName: 'Наименование товара',
  productGroup: 'Товарная группа',
  brand: 'Бренд',
  tnVedEaes: 'Код ТН ВЭД ЕАЭС',
  tnVedEaesGroup: 'Группа ТН ВЭД ЕАЭС',
  packType: 'Тип упаковки',
  generalPackageType: 'Общий тип упаковки',
  markWithdraw: 'Изъят из оборота',
};

const ResponseView = ({ cisInfo, errorMessage }) => {
  if (errorMessage) {
    return (
      <Card style={styles.responseCard}>
        <CardContent>
          <Typography style={{ color: '#d32f2f', fontWeight: 600 }}>{errorMessage}</Typography>
        </CardContent>
      </Card>
    );
  }
  if (!cisInfo) return null;

  return (
    <Card style={styles.responseCard}>
      <CardContent>
        {Object.entries(cisInfo)
          .filter(([, val]) => val !== null && val !== undefined && val !== '' && !Array.isArray(val))
          .map(([key, val]) => (
            <div key={key} style={styles.responseRow}>
              <span style={styles.responseKey}>{CIS_INFO_LABELS[key] || key}</span>
              <span style={styles.responseVal}>{typeof val === 'object' ? JSON.stringify(val) : String(val)}</span>
            </div>
          ))}
      </CardContent>
    </Card>
  );
};

class AppModule extends Component {
  defaultParams = {};

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      executingFile: false,
      executingUit: false,
      errorFile: null,
      uitCode: '',
      uitResponse: null,
    };
  }

  componentDidMount = () => {
    this.checkLocation();
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.location.search !== prevProps.location.search) {
      this.checkLocation();
    }
  };

  checkLocation = () => {
    if (this.props.location.search.length < 2) {
      this.resetState();
      return;
    }
    const params = qs.parse(this.props.location.search.slice(1));
    if (!(resourceConfig.urlParamName in params)) {
      this.resetState();
      return;
    }
    if (this.state.show) {
      return;
    }
    const data = paramToDictionary(params[resourceConfig.urlParamName]);
    this.setState({
      show: true,
      params: { ...this.defaultParams, ...data },
    });
  };

  resetState = () => {
    this.setState({ show: false, executingFile: false, executingUit: false });
    setTimeout(this.afterClose, 500);
  };

  afterClose = () => {
    this.setState({
      params: { ...this.defaultParams },
      errorFile: null,
      uitCode: '',
      uitResponse: null,
    });
  };

  executeFile = async (formData) => {
    this.setState({ executingFile: true, errorFile: null });

    const fetchBody = new FormData();
    if (formData.file && formData.file.rawFile) {
      fetchBody.append('file', formData.file.rawFile);
    }
    if (formData.addresses && formData.addresses.length > 0) {
      formData.addresses.forEach((it) => fetchBody.append('addresses', it.address));
    }

    let response = null;
    let errorFile = null;
    try {
      response = await request({
        apiService: resourceConfig.apiService,
        path: resourceConfig.apiPath,
        body: fetchBody,
        method: 'POST',
      });
    } catch (e) {
      console.error(e);
    }
    if (response === null || !response.ok) {
      this.props.showNotification(`resources.${resourceConfig.name}.errorMessage`, 'error');
      if (response !== null) {
        errorFile = response.data;
      }
    } else {
      this.props.showNotification(`resources.${resourceConfig.name}.successMessage`, 'success');
    }

    this.setState({ executingFile: false, errorFile });
  };

  executeUit = async () => {
    const { uitCode } = this.state;
    if (!uitCode) return;

    this.setState({ executingUit: true, uitResponse: null });

    let response = null;
    try {
      response = await request({
        apiService: resourceConfig.apiService,
        path: `${resourceConfig.apiPath}/by-uit`,
        body: JSON.stringify({ uitCode }),
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
      });
    } catch (e) {
      console.error(e);
    }

    if (response === null || !response.ok) {
      this.props.showNotification(`resources.${resourceConfig.name}.errorMessage`, 'error');
      this.setState({ executingUit: false, uitResponse: { errorMessage: response && response.data ? (response.data.exMessage || response.data.message || 'Ошибка запроса') : 'Ошибка запроса' } });
    } else {
      this.setState({ executingUit: false, uitResponse: response.data });
    }
  };

  handleCloseClick = () => {
    this.props.history.goBack();
  };

  render() {
    const { translate } = this.props;
    const { uitCode, executingUit, uitResponse, errorFile } = this.state;

    return (
      <Drawer anchor={'right'} open={this.state.show} onClose={this.handleCloseClick}>
        <div style={{ width: 700, maxWidth: '90vw', padding: '0 24px 24px' }}>
          <Typography variant={'title'} style={{ padding: '16px 0' }}>
            {translate(`resources.${resourceConfig.name}.title`)}
          </Typography>

          {/* Блок 1: загрузка xlsx + адреса */}
          <Typography variant={'subheading'} style={styles.sectionTitle}>
            {translate(`resources.${resourceConfig.name}.sectionFile`)}
          </Typography>
          <SimpleForm
            defaultValue={this.state.params}
            save={this.executeFile}
            toolbar={<FormToolbar />}
            saving={this.state.executingFile}
          >
            <FileInput
              source="file"
              label={translate(`resources.${resourceConfig.name}.fields.file`)}
              accept=".xlsx"
            >
              <FileField source="src" title="title" />
            </FileInput>

            <ArrayInput
              source="addresses"
              label={translate(`resources.${resourceConfig.name}.fields.addresses`)}
            >
              <SimpleFormIterator>
                <TextInput
                  source="address"
                  label={translate(`resources.${resourceConfig.name}.fields.address`)}
                />
              </SimpleFormIterator>
            </ArrayInput>

            {errorFile && (
              <Snackbar
                style={{ marginTop: 16, maxWidth: '100%' }}
                textStyle={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}
                showIcon={false}
                variant="error"
                message={errorFile.exMessage || errorFile.message}
                fullWidth
              />
            )}
          </SimpleForm>

          <Divider style={styles.divider} />

          {/* Блок 2: код маркировки */}
          <Typography variant={'subheading'} style={styles.sectionTitle}>
            {translate(`resources.${resourceConfig.name}.sectionUit`)}
          </Typography>
          <div style={styles.uitRow}>
            <MuiTextField
              style={styles.uitField}
              label={translate(`resources.${resourceConfig.name}.fields.uitCode`)}
              value={uitCode}
              onChange={(e) => this.setState({ uitCode: e.target.value, uitResponse: null })}
              variant="filled"
              size="small"
            />
            <Button
              style={styles.submitBtn}
              variant="contained"
              color="primary"
              disabled={!uitCode || executingUit}
              onClick={this.executeUit}
            >
              {executingUit
                ? <CircularProgress size={20} color="inherit" />
                : translate(`resources.${resourceConfig.name}.executeActionUit`)}
            </Button>
          </div>

          {uitResponse && (
            <ResponseView
              cisInfo={uitResponse.cisInfo}
              errorMessage={uitResponse.errorMessage}
            />
          )}
        </div>
      </Drawer>
    );
  }
}

export default compose(
  withRouter,
  connect(null, { showNotification }),
  translate,
  withStyles(styles),
)(AppModule);
